export enum Sterilization {
  OVARIECTOMY = 'ovariectomy',
  OVARIOHYSTERECTOMY = 'ovariohysterectomy',
  CASTRATION = 'castration',
}
